'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _ConfirmationInfoSectionComponent = require('../../components/common/ConfirmationInfoSectionComponent');

var _ConfirmationInfoSectionComponent2 = _interopRequireDefault(_ConfirmationInfoSectionComponent);

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders the confirmation page of the form.
 * @extends {Component}
 */
var ConfirmationComponent = function ConfirmationComponent(_ref) {
  var confirmation = _ref.confirmation;

  var applicationId = confirmation.application_id || '';

  if (confirmation.body === undefined) {
    return _react2.default.createElement(
      'div',
      { className: 'error' },
      ' ',
      '' + (0, _translate.t)('A system error occurred, please contact your agent to confirm the status of the application.'),
      ' ',
      _react2.default.createElement('br', null),
      ' ',
      (0, _translate.t)('Application ID') + ': ' + applicationId,
      ' '
    );
  }

  var headerText = confirmation.header_text.split('<br><br>');
  return _react2.default.createElement(
    _reactBootstrap.Grid,
    { fluid: true },
    _react2.default.createElement(
      _reactBootstrap.Row,
      null,
      _react2.default.createElement(
        _reactBootstrap.Col,
        { xs: 12 },
        _react2.default.createElement(
          _reactBootstrap.Panel,
          {
            header: _react2.default.createElement(
              _reactBootstrap.Row,
              null,
              _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: 6 },
                confirmation.title
              ),
              _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: 6 },
                (0, _translate.t)('Application ID') + ': ' + applicationId
              )
            ),
            bsStyle: 'success'
          },
          _react2.default.createElement(
            _reactBootstrap.Row,
            { style: { paddingBottom: 10 } },
            _react2.default.createElement(
              _reactBootstrap.Col,
              { xs: 7 },
              _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: headerText[0] } })
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { xs: 12 },
              _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: headerText[1] } })
            )
          )
        )
      ),
      confirmation.body.map(function (node) {
        return _react2.default.createElement(_ConfirmationInfoSectionComponent2.default, {
          section: node
        });
      }),
      _react2.default.createElement(
        _reactBootstrap.Col,
        { xs: 12 },
        _react2.default.createElement(
          _reactBootstrap.Panel,
          null,
          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: confirmation.legal_text } })
        )
      )
    )
  );
};

ConfirmationComponent.propTypes = {
  confirmation: _react2.default.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    confirmation: state.application.confirmation
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ConfirmationComponent);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/common/ConfirmationContainer.jsx
// module id = 19
// module chunks = 0